module.exports = __webpack_public_path__ + "static/media/redux-logo-white.8c0f1253.svg";